import { registerComponent } from '@gig/magic-common';
import GridComponent from './grid.vue.js';

var Grid = registerComponent(GridComponent);

export { Grid };
